// extracted by extract-css-chunks-webpack-plugin
module.exports = {"accordion":"_2IqBqp","icon":"fVjo22","question":"yse4od","open":"Hx05Kg","answer":"_3ghL5V","inner":"_28qULj","imageWrapper":"_184lfe"};